import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";

export const DefaultGroups = ({
  name,
  rCase = "row",
  onChange,
  value,
  list,
}) => {
  return (
    <RadioGroup
      row
      aria-labelledby="demo-row-radio-buttons-group-label"
      name="row-radio-buttons-group"
      onChange={onChange}
      value={value}
    >
      {list.map((data, index) => {
        return (
          <FormControlLabel
            key={data.index}
            value={data.value}
            control={
              <Radio
                color="default"
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 24,
                  },
                }}
              />
            }
            label={<Typography variant="body">{data.name}</Typography>}
          />
        );
      })}
    </RadioGroup>
  );
};
